import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "normalize.css/normalize.css";
import Vant from "vant";
import "vant/lib/index.css";
import "amfe-flexible";
import qs from "qs";

// import VConsole from "vconsole";

Vue.prototype.$qs = qs;
Vue.config.productionTip = false;
Vue.use(Vant);
// new VConsole();

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
